<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created: function () {},
  //利用计算属性
  //   computed: {
  //     changeMemberTab() {
  //       return this.$store.state.sealData.loading
  //     }
  //   },
  //   //监听执行
  //   watch: {
  //     changeMemberTab(val) {
  // 		let _aa = setInterval(val => {
  // 			if(loadingInstance){

  // 				loadingInstance.close()
  // 			}
  // 		},500)
  //     }
  //   },
};
</script>

<style lang="scss">
@import "./assets/css/conmon.css";
@import "../static/csslib/iconfont/iconfont.css";

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  padding-right: 0 !important;
}
.el-dialog__body {
  padding: 5px 20px;
}
.el-cascader-panel .el-radio {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 0px;
  right: 2px;
}
.el-cascader-panel .el-radio__input {
  visibility: hidden;
}
.el-cascader-panel .el-cascader-node__postfix {
  top: 10px;
}
.el-scrollbar__bar.is-horizontal {
  height: 0;
}
.el-scrollbar__wrap {
  overflow: auto !important;
}

// 06月23
.sisi-wrap-columns {
  .el-tabs__item {
    font-size: 16px;
    // background:red;
  }
}
.el-tabs__item {
  font-size: 16px;
  // background:red;
}

.sisi-wrap-columns {
  .el-input--suffix .el-input__inner {
    height: 32px;
  }
}

.justify-center {
  justify-content: center;
}

.flex {
  display: flex;
}

.app-clear-both {
  width: 100%;
  height: 0px;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/App.vue